(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('PromoCodeDialogController', PromoCodeDialogController);

    PromoCodeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PromoCode','PromoCodeTag'];

    function PromoCodeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PromoCode,PromoCodeTag) {
        var vm = this;

        vm.promoCode = entity;
        vm.clear = clear;
        vm.save = save;
        vm.addTag = addTag;
        vm.removeTag = removeTag;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.finishDate = false;

        console.log( vm.promoCode);
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
            loadAllPromoCodeTags();
            loadAllTags();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.promoCode.id !== null) {
                PromoCode.update(vm.promoCode, onSaveSuccess, onSaveError);
            } else {
                PromoCode.save(vm.promoCode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:promoCodeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }



        function loadAllTags(){
            if(vm.promoCode.id){
                PromoCodeTag.tagsAvailable({}, function (data) {
                    vm.tagsAvailable = data;
                    console.log(data);
                });
            }
        }

        function loadAllPromoCodeTags(){
            if(vm.promoCode.id){
                PromoCodeTag.allPromoCodeTags({promoCodeId: vm.promoCode.id}, function (data) {
                    vm.promoCodeTags = data;
                    console.log(data);
                });
            }

        }

        function addTag(){

            var notContains = true;

            if(vm.promoCodeTags && vm.promoCodeTags.length > 0){
                for (var x = 0; x < vm.promoCodeTags.length; x++) {
                    if (vm.promoCodeTags[x].id === vm.tagSelected.id) {
                        notContains = false;
                    }
                }
            }


            if(notContains){
                PromoCodeTag.addTag({promoCodeId: vm.promoCode.id,tagId:vm.tagSelected.id},null, function (data) {
                    vm.promoCodeTags.push(angular.copy(vm.tagSelected));
                    vm.tagSelected = null;
                });
            }else{
                vm.tagSelected = null;
            }

        }

        function removeTag(tag,idx){
            PromoCodeTag.removeTag({promoCodeId: vm.promoCode.id,tagId:tag.id}, function (data) {
                vm.tagSelected = null;
                vm.promoCodeTags.splice(idx,1);
            });
        }

    }
})();
